<div class="sercon-hero mobi-ui-margin-b-xxxl smMax:full-bleed">
  <div class="smMax:!container-padding">
    <mobi-breadcrumb />
  </div>
  <div
    class="mobi-ui-card-silent mobi-ui-relative mobi-ui-padding-y-lg mobi-ui-margin-t-sm mobi-ui-padding-x-none view-enter-animation smMax:!container-padding"
  >
    <div class="mobi-ui-grid is-align-center">
      <div class="mobi-ui-col-1/1 md:mobi-ui-col-8/16 md:mobi-ui-offset-1/16">
        <mobi-hero-text
          [superTitle]="entity().superTitle"
          [subtitle]="entity().subtitle"
          [lead]="entity().lead"
          [title]="entity().title"
          [fullWidth]="true"
        />
      </div>
      <!-- Illustration above the emergency CTA, phones and tablets show only the CTA -->
      <div
        class="mobi-ui-col-1/1 md:mobi-ui-col-5/16 md:mobi-ui-offset-1/16 flex flex-col items-center"
      >
        @if (entity().heroIllustration) {
          @defer (hydrate never) {
            <mobi-ui-illustration-major
              class="smMax:hidden w-80 mobi-ui-margin-b-sm"
              [illustration]="entity().heroIllustration"
              [lazy]="false"
            />
          }
        }
        @if (entity().emergencyCta | extractUrl) {
          <mobi-icon-cta
            class="block w-full md:w-auto [&_a]:!bg-bg-0"
            [url]="entity().emergencyCta | extractUrl"
            [target]="entity().emergencyCta?.options?.attributes?.target"
            [title]="entity().emergencyCtaLabel"
            [secondaryLabel]="entity().emergencyCta?.title"
            [icon]="emergencyCtaIcon.symbol"
          />
        }
      </div>
    </div>
  </div>
</div>
<div class="split-button-wrapper w-full mx-auto is-bottom-center hide-scrollbars">
  <div class="w-full md:w-fit md:min-w-[400px] mx-auto">
    @if (visiblePage().length > 0) {
      <mobi-ui-split-button-group-supreme
        class="is-rounded is-large"
        [value]="visiblePage()"
        [class.initial-contact]="visiblePage() === 'contact' && !hasSwitchedPage()"
        (valueChange)="changePage('' + $event)"
        #splitButton
      >
        <mobi-ui-split-button-supreme
          class="mobi-ui-padding-x-xxxl"
          value="services"
          [active]="visiblePage() === 'services'"
        >
          <span class="whitespace-nowrap">
            {{
              'online_services_label'
                | texts: { context: 'frontend', default: 'Online Services' }
            }}
          </span>
        </mobi-ui-split-button-supreme>
        <mobi-ui-split-button-supreme
          class="mobi-ui-padding-x-xxxl"
          value="contact"
          [active]="visiblePage() === 'contact'"
        >
          <span class="whitespace-nowrap">
            {{ 'contact_label' | texts: { context: 'frontend', default: 'Kontakt' } }}
          </span>
        </mobi-ui-split-button-supreme>
      </mobi-ui-split-button-group-supreme>
    }
  </div>
</div>
<div id="scroll-to-view"></div>
@if (visiblePage() === 'services') {
  <div id="services-page" class="main-services">
    <div class="page-content !mt-0">
      <mobi-content-section width="full" [content]="mainServices" [background]="true">
        <ng-template #mainServices>
          <mobi-section-title
            class="block mobi-ui-padding-t-sm xsMax:!pt-10 mobi-ui-padding-b-xxl"
            [title]="entity().mainServicesTitle"
          />
          <div class="mobi-ui-grid is-centered">
            <div
              class="mobi-ui-col-1/1 md:mobi-ui-col-7/8 lg:mobi-ui-col-1/1 xl:mobi-ui-col-7/8"
            >
              @defer (hydrate on viewport) {
                @if (mainTeasers().length > 0) {
                  <mobi-teaser-list
                    [teasers]="mainTeasers()"
                    teaserStyle="icon-stacked-bottom"
                    [inked]="true"
                    [isMobileSlider]="false"
                    [serviceLayout]="true"
                  />
                }
              }
            </div>
            <div class="mobi-ui-col-1/1 lg:mobi-ui-col-5/8 no-heading-spacing">
              <h5 class="mobi-ui-text-inked mobi-ui-text-center mobi-ui-padding-b-md">
                {{
                  'further_topics_on_this_page_label'
                    | texts
                      : {
                          context: 'frontend',
                          default: 'Weitere Themen auf dieser Seite',
                        }
                }}
              </h5>
              @if (contentLinks()) {
                <mobi-content-links [contentLinks]="contentLinks()" [isCentered]="true" />
              }
            </div>
          </div>
        </ng-template>
      </mobi-content-section>
      @for (section of serviceSections(); track section.key) {
        @if (section.services?.length) {
          <div class="content-section mobi-ui-padding-t-xxl">
            <div>
              <mobi-service-infobox
                [superTitle]="section.superTitle"
                [title]="section.title"
                [services]="section.services"
                [sectionId]="
                  section.idKey
                    | texts: { context: 'frontend', default: section.idDefault }
                "
                [illustration]="section.illustration"
              />
            </div>
          </div>
        }
      }
      <div class="content-section is-background !mt-24 xs:!mt-32">
        <div><mobi-concierge /></div>
      </div>
    </div>
  </div>
}
@if (visiblePage() === 'contact') {
  <div
    id="contact-page"
    class="view-enter-animation"
    [class.hidden]="visiblePage() !== 'contact'"
  >
    <div class="page-content !mt-0">
      <h2 class="text-center mobi-ui-padding-t-sm xsMax:!pt-10 mobi-ui-padding-b-xxl">
        {{
          'ga_search_map_title'
            | texts
              : {
                  context: 'frontend',
                  default: 'Finden Sie die Filiale in Ihrer Nähe.',
                }
        }}
      </h2>

      <div class="content-section">
        <div>
          <div id="map" class="mobi-ui-grid is-centered">
            <div class="mobi-ui-col-1/1 xl:mobi-ui-col-3/4">
              <mobi-ga-search />
            </div>
          </div>
        </div>
      </div>
      @if (entity().contactParagraphs) {
        @for (paragraph of entity().contactParagraphs; track paragraph?.uuid ?? $index) {
          @if (paragraph) {
            <mobi-paragraph-loader
              [bundle]="paragraph.type"
              [data]="{ paragraph: paragraph }"
            />
          }
        }
      }
    </div>
  </div>
}

<ng-template #pgs let-paragraph="paragraph">
  @if (paragraph.type === 'ParagraphPgTl') {
    <mobi-paragraph-loader
      [bundle]="paragraph.type"
      [data]="{
        paragraph: paragraph,
        teaserStyle: 'stacked',
      }"
    />
  } @else if (paragraph.type === 'ParagraphPgForm') {
    <div class="is-background">
      <ng-content /><mobi-paragraph-loader
        [bundle]="paragraph.type"
        [data]="{ paragraph: paragraph }"
      />
    </div>
  } @else {
    <mobi-paragraph-loader [bundle]="paragraph.type" [data]="{ paragraph: paragraph }" />
  }
</ng-template>
